import Link from 'next/link'
import React from 'react'

const Noref = () => {
    return (
        <li className='item'>
            <Link href='#'>
                ...
            </Link>
        </li>
    )
}

export default Noref